var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-img-wrapper" },
    [
      _c("vs-avatar", {
        staticClass: "page-img",
        attrs: {
          size: "33px",
          src: _vm.page.avatar,
          loading: "lazy",
          alt: "page",
        },
      }),
      _c(
        "div",
        { staticClass: "rs" },
        [
          _vm.page.network === "facebook"
            ? _c("vs-avatar", {
                attrs: {
                  color: "transparent",
                  size: "18px",
                  src: require("../../assets/img/icon_fb.png"),
                },
              })
            : _vm.page.network === "twitter"
            ? _c("vs-avatar", {
                attrs: {
                  color: "transparent",
                  size: "18px",
                  src: require("../../assets/img/icon_tw.png"),
                },
              })
            : _vm.page.network === "linkedin"
            ? _c("vs-avatar", {
                attrs: {
                  color: "transparent",
                  size: "18px",
                  src: require("../../assets/img/icon_linkedin.png"),
                },
              })
            : _vm.page.network === "telegram"
            ? _c("vs-avatar", {
                attrs: {
                  color: "transparent",
                  size: "18px",
                  src: require("../../assets/img/icon_telegram.png"),
                },
              })
            : _vm.page.network === "bluesky"
            ? _c("vs-avatar", {
                attrs: {
                  color: "transparent",
                  size: "18px",
                  src: require("../../assets/img/icon_bluesky.png"),
                },
              })
            : _vm.page.network === "instagram"
            ? _c("vs-avatar", {
                attrs: {
                  color: "transparent",
                  size: "18px",
                  src: require("../../assets/img/icon_instagram.png"),
                },
              })
            : _vm.page.network === "pinterest"
            ? _c("vs-avatar", {
                attrs: {
                  color: "transparent",
                  size: "18px",
                  src: require("../../assets/img/icon_pinterest.png"),
                },
              })
            : _vm.page.network === "google"
            ? _c("vs-avatar", {
                attrs: {
                  color: "transparent",
                  size: "18px",
                  src: require("../../assets/img/ico-google-circle.png"),
                },
              })
            : _vm.page.network === "oneSignal"
            ? _c("vs-avatar", {
                attrs: {
                  color: "transparent",
                  size: "18px",
                  src: require("../../assets/img/icon_onesignal.png"),
                },
              })
            : _vm.page.network === "wonderpush"
            ? _c("vs-avatar", {
                attrs: {
                  color: "transparent",
                  size: "18px",
                  src: require("../../assets/img/icon_wonderpush.png"),
                },
              })
            : _vm.page.network === "batch"
            ? _c("vs-avatar", {
                attrs: {
                  color: "transparent",
                  size: "18px",
                  src: require("../../assets/img/icon_batch.png"),
                },
              })
            : _vm.page.network === "tiktok"
            ? _c("vs-avatar", {
                attrs: {
                  color: "transparent",
                  size: "18px",
                  src: require("../../assets/img/icon_tiktok.png"),
                },
              })
            : _vm.page.network === "youtube"
            ? _c("vs-avatar", {
                attrs: {
                  color: "transparent",
                  size: "18px",
                  src: require("../../assets/img/ico-youtube-circle.svg"),
                },
              })
            : _vm.page.network === "threads"
            ? _c("vs-avatar", {
                attrs: {
                  color: "transparent",
                  size: "18px",
                  src: require("../../assets/img/icon_threads.png"),
                },
              })
            : _vm.page.network === "whatsapp"
            ? _c("vs-avatar", {
                attrs: {
                  color: "transparent",
                  size: "18px",
                  src: require("../../assets/img/icon_whatsapp.png"),
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }